<script>
export default {
  name: 'RightDrawerHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    showBack: {
      type: Boolean,
      default: false
    },
    backLabel: {
      type: String,
      default: null
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: false
    },
    closeLabel: {
      type: String,
      default: null
    }
  },
  computed: {
    resolvedBackLabel() {
      return this.backLabel || this.$t('COMMON.BUTTON.CANCEL')
    },
    resolvedCloseLabel() {
      return this.closeLabel || this.$t('COMMON.BUTTON.CANCEL')
    }
  }
}
</script>

<template>
  <div
    class="right-drawer-header d-flex align-center ga-3"
    :class="{ 'right-drawer-header--bordered': showBorder }"
  >
    <v-btn-icon
      v-if="showBack"
      :aria-label="resolvedBackLabel"
      :title="resolvedBackLabel"
      icon="mdi-arrow-left"
      @click="$emit('back')"
    />
    <p class="right-drawer-header-title">{{ title }}</p>
    <v-btn-icon
      v-if="showClose"
      class="right-drawer-header-close"
      :aria-label="resolvedCloseLabel"
      :title="resolvedCloseLabel"
      icon="mdi-close"
      @click="$emit('close')"
    />
  </div>
</template>

<style scoped>
.right-drawer-header {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  min-height: 47px;
  margin-inline: calc(-1 * var(--rm-drawer-padding));
  padding: 8px var(--rm-drawer-padding) 16px;
  background: var(--default-background-color);
}

.right-drawer-header--bordered {
  border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.right-drawer-header-title {
  font-size: 22px;
  font-weight: 600;
  line-height: 1.2;
}

.right-drawer-header-close {
  margin-left: auto;
}
</style>
